// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__Anwos","details":"Register_details__PkDyf","btn":"Register_btn__fALEh","nav":"Register_nav__hkMe-","bottom":"Register_bottom__Ku4sH"};